import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionTemplateCreatePayload } from 'api/actions/revision-template-create/revision-template-create-payload';
import { RevisionTemplateCreatePathParameters } from 'api/actions/revision-template-create/revision-template-create-path-parameters';
import { RevisionTemplateCreateResponse } from 'api/actions/revision-template-create/revision-template-create-response';

type RevisionTemplateCreateQueryParameters = Record<string, any>;

/**
 * The path of the RevisionTemplateCreate action.
 */
export const revisionTemplateCreateActionPath = new SweetPath<keyof RevisionTemplateCreatePathParameters>(
  '/api/revision-template/create',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionTemplateCreate actions.
 */
export default function createRevisionTemplateCreateAction(axios: AxiosInstance) {
  return function revisionTemplateCreateAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: RevisionTemplateCreateQueryParameters;
    payload: RevisionTemplateCreatePayload;
  }) {
    const path = revisionTemplateCreateActionPath.original;

    return axios.request<RevisionTemplateCreateResponse, RevisionTemplateCreateResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
